import styled, { css, keyframes } from "styled-components";
import { HXButton } from "../HXButton";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { FlexRowDiv } from "../common.styles";
import { JOB_STATE_COLORS } from "healthex-common/job-management.dtos";
export const JobManagementViewParent = styled.div ``;
export const QueueTable = styled.table `
    font-size: ${fontSizes.SMALL};
    margin-top: 5px;
    width: 100%;
    border: 2px solid ${colors.black_30};
    border-collapse: collapse;

    & th {
        text-align: center;
        font-weight: 600;
    }

    & th,
    td {
        padding: 8px 10px;
        vertical-align: middle;
        text-align: center;
    }

    & tbody tr:nth-child(odd) {
        background-color: ${colors.black_4};
    }

    & tbody tr:hover {
        background-color: ${colors.black_8};
    }
`;
export const QueueNameCell = styled.td `
    text-align: left !important;
    font-weight: 500;
`;
export const ArchivedQueueRow = styled.tr `
    opacity: 0.6;
    background-color: ${colors.black_8} !important;

    &:hover {
        opacity: 0.8;
    }
`;
export const ArchivedBadge = styled.span `
    display: inline-block;
    padding: 2px 6px;
    margin-left: 8px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    background-color: ${colors.black_30};
    color: ${colors.black_lighter};
`;
export const ActionTableCell = styled.td `
    width: 200px;
    text-align: right !important;
`;
export const ActionButtonsWrapper = styled(FlexRowDiv) `
    gap: 8px;
    justify-content: flex-end;
`;
export const Section = styled.div `
    width: 100%;
    max-width: 1000px;
    margin-bottom: 30px;
`;
export const SectionHeaderWrapper = styled.div `
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`;
export const SectionHeader = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: 600;
`;
export const SectionActionButton = styled(HXButton) `
    display: block;
    margin-left: auto;
    margin-right: 10px;
`;
const pulse = keyframes `
    0%, 100% { opacity: 1; }
    50% { opacity: 0.6; }
`;
export const StateBadge = styled.span `
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: white;
    background-color: ${(props) => JOB_STATE_COLORS[props.state]};
    ${(props) => props.state === "active" &&
    css `
            animation: ${pulse} 1.5s ease-in-out infinite;
        `}
`;
export const CountBadge = styled.span `
    display: inline-block;
    min-width: 24px;
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    background-color: ${(props) => {
    switch (props.variant) {
        case "error":
            return colors.tulip_main;
        case "warning":
            return "#FF9800";
        case "info":
            return "#9E9E9E";
        default:
            return colors.black_30;
    }
}};
    color: ${(props) => (props.variant && props.variant !== "default" ? "white" : colors.black_main)};
`;
export const SummaryStats = styled(FlexRowDiv) `
    gap: 24px;
    margin-bottom: 16px;
    padding: 12px 16px;
    background-color: ${colors.black_4};
    border-radius: 8px;
`;
export const StatItem = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
`;
export const StatValue = styled.div `
    font-size: 24px;
    font-weight: 600;
`;
export const StatLabel = styled.div `
    font-size: 12px;
    color: ${colors.black_lighter};
    text-transform: uppercase;
`;
export const JobDetailSection = styled.div `
    margin-bottom: 16px;
`;
export const JobDetailLabel = styled.div `
    font-size: 12px;
    font-weight: 600;
    color: ${colors.black_lighter};
    margin-bottom: 4px;
    text-transform: uppercase;
`;
export const JobDetailValue = styled.div `
    font-size: 14px;
`;
export const JobDataPre = styled.pre `
    background-color: ${colors.black_4};
    padding: 12px;
    border-radius: 4px;
    font-size: 12px;
    overflow-x: auto;
    max-height: 300px;
    overflow-y: auto;
`;
export const TabsContainer = styled.div `
    margin-bottom: 20px;
`;
export const EmptyState = styled.div `
    text-align: center;
    padding: 40px;
    color: ${colors.black_lighter};
    font-size: 14px;
`;
export const ScheduleTable = styled(QueueTable) `
    & td:first-child {
        text-align: left;
        font-weight: 500;
    }
`;
export const CronExpression = styled.code `
    background-color: ${colors.black_8};
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 12px;
`;
export const RefreshButton = styled(HXButton) `
    margin-left: 8px;
`;
export const InlineActionButton = styled(HXButton) `
    padding: 4px 8px;
    font-size: 11px;
    min-width: auto;
`;
